"use client";
import type { CSSProperties, ReactElement, ReactNode } from "react";
import { ButtonPreset } from "@/constants/componentPresets";
import { Cbutton } from "../Cbutton";
const TOOLBAR_BUTTON_HEIGHT = 32;
const TOOLBAR_BUTTON_CONTENT_STYLE: CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    fontSize: 14,
    fontWeight: 700,
    color: "rgba(255,255,255,0.76)",
};
export interface GanttToolbarButtonProps {
    onClick: () => void;
    label: string;
    disabled?: boolean;
    children: ReactNode;
}
export function GanttToolbarButton({ onClick, label, disabled = false, children, }: GanttToolbarButtonProps): ReactElement {
    return (
      <Cbutton preset={ButtonPreset.Ghost} radius={6} padding="0 10px" height={TOOLBAR_BUTTON_HEIGHT} onClick={onClick} disabled={disabled}>
        <span aria-label={label} title={label} style={TOOLBAR_BUTTON_CONTENT_STYLE}>
          {children}
        </span>
      </Cbutton>
    );
}
